import config from '@/core/config/config';
import { CURRENT_USER } from '@/graphql/queries';
import { customFetcher, getGqlString } from '@/utils/customFetcher';
import { swrConfig } from '@/utils/swrConfig';
import { useCookies } from 'react-cookie';
import useSWRImmutable from 'swr/immutable';

// TODO: Using native fetch here as graphql-request does not support cookies. Consider updating if support is added in the future.
const currentUserFetcher = async (gqlDocument: any) => {
  return customFetcher(config.PII_SERVER, {
    query: getGqlString(gqlDocument),
  });
};

export const useCurrentUser = () => {
  const [cookies] = useCookies();
  const userIsNotLoggedIn = !cookies.prenuvoLOGIN;

  const { data, error, isLoading } = useSWRImmutable(
    userIsNotLoggedIn ? null : CURRENT_USER,
    currentUserFetcher,
    swrConfig,
  );
  return { data: data?.data?.currentUser, error, isLoading };
};
